import { type SVGProps } from 'react';

import { cn } from '@shared/utils';

export interface LwartLogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function LwartLogo({ className, ...props }: Readonly<LwartLogoProps>) {
  return (
    <svg
      width="151"
      height="48"
      viewBox="0 0 151 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-label="Lwart - Soluções Ambientais"
      role="img"
      {...props}
    >
      <g clipPath="url(#clip0_4307_143312)">
        <mask
          id="mask0_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask0_4307_143312)">
          <path
            d="M122.993 30.724C122.658 30.724 122.371 30.5804 122.179 30.2933C121.03 28.6661 119.977 27.1347 118.924 25.6512C118.924 25.6512 118.924 25.6512 118.876 25.6033C117.679 25.6033 112.939 25.6033 112.939 25.6033V30.6761H108.535V15.3621C108.535 15.3621 119.115 15.3621 121.365 15.4099C123.137 15.4099 124.669 16.1278 125.722 17.4677C126.584 18.5206 126.919 20.0998 126.679 21.6313C126.44 22.9712 125.77 24.0719 124.717 24.6941C124.381 24.8855 124.046 25.0291 123.711 25.1726L127.541 30.7718C127.541 30.724 123.328 30.724 122.993 30.724ZM116.003 21.9662C117.583 21.9662 119.115 21.9662 120.695 21.9662C120.934 21.9662 121.222 21.9184 121.509 21.7748C122.179 21.5355 122.514 20.8656 122.323 20.1956C122.179 19.5256 121.557 19.1427 120.743 19.1427C119.45 19.1427 118.205 19.1427 116.913 19.1427H112.939V22.0141L116.003 21.9662ZM89.7673 30.7718C90.0545 30.7718 90.2939 30.6283 90.4375 30.389C90.8684 29.5276 91.4908 28.4269 91.8738 27.6612C91.8738 27.6612 91.8738 27.6612 91.8738 27.6133C93.3101 27.6133 94.7463 27.6133 96.1826 27.6133C97.6668 27.6133 99.103 27.6133 100.587 27.6133C100.587 27.6133 100.587 27.6133 100.587 27.6612C100.779 28.044 100.97 28.379 101.162 28.7619C101.305 29.049 101.688 29.7668 102.023 30.389C102.167 30.6283 102.406 30.7718 102.694 30.7718H106.811C106.811 30.7718 100.874 19.5734 98.9115 15.8885C98.72 15.5535 98.4807 15.4099 98.0977 15.4099C97.4753 15.4099 94.9857 15.4099 94.3633 15.4099C93.9325 15.4099 93.6452 15.6013 93.4537 15.9842C91.5387 19.6213 85.6021 30.8197 85.6021 30.8197H89.7673V30.7718ZM96.2305 19.4299L98.6722 23.9284H93.8367L96.2305 19.4299ZM140.276 30.724V19.047H146.644C146.931 19.047 147.17 18.8077 147.17 18.5206V15.4099H128.977V18.5684C128.977 18.8556 129.217 19.0949 129.504 19.0949H135.872V30.724H140.276ZM46.344 30.7718H59.6535L58.0736 27.0869H49.2166C48.7378 27.0869 48.3548 26.704 48.3548 26.2255V15.4578H43.9023V28.3312C43.9023 29.6711 45.0035 30.7718 46.344 30.7718ZM70.0425 15.4099C69.7074 15.4099 69.5637 15.4578 69.468 15.7449C68.319 19.2384 65.8294 26.4169 65.7815 26.6083C65.6858 26.4169 62.3824 18.1856 61.5206 16.0799C61.377 15.6971 60.994 15.4099 60.5631 15.4099C59.6056 15.4099 56.7809 15.4099 56.7809 15.4099L63.1005 30.1497C63.1005 30.1497 63.2441 30.6761 63.8665 30.6761C65.3507 30.6761 66.4518 30.6761 67.936 30.6761C68.4147 30.6761 68.6062 30.2933 68.6062 30.2933L72.4363 19.047L76.2663 30.2933C76.2663 30.2933 76.41 30.6761 76.9366 30.6761C78.4207 30.6761 79.5219 30.6761 81.006 30.6761C81.6284 30.6761 81.772 30.1497 81.772 30.1497L88.0916 15.4099C88.0916 15.4099 85.267 15.4099 84.3095 15.4099C83.8786 15.4099 83.4956 15.6492 83.3519 16.0799C82.4902 18.1856 79.1867 26.4648 79.091 26.6083C78.9952 26.4169 76.5536 19.2384 75.4046 15.7449C75.3088 15.4578 75.1652 15.4099 74.8301 15.4099C73.1544 15.4578 71.6224 15.4578 70.0425 15.4099Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask1_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask1_4307_143312)">
          <path
            d="M47.1092 38.0938C47.1092 39.0509 46.1516 39.2902 45.4335 39.2902C45.0026 39.2902 43.9015 39.2902 43.6621 38.2852L44.3324 37.9502C44.6196 38.4766 45.0505 38.5245 45.3378 38.5245C45.625 38.5245 46.2953 38.5245 46.2953 38.1416C46.2953 37.4238 43.6621 38.2852 43.6621 36.7538C43.6621 36.0359 44.5239 35.6531 45.3378 35.6531C46.1516 35.6531 46.9177 35.9881 47.0134 36.6581L46.4389 36.9452C46.2953 36.5145 45.8165 36.3709 45.3856 36.3709C44.9548 36.3709 44.5239 36.5145 44.5239 36.7538C44.5717 37.4238 47.1092 36.6581 47.1092 38.0938Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask2_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask2_4307_143312)">
          <path
            d="M49.5039 37.5195C49.5039 36.4188 50.222 35.7009 51.2753 35.7009C52.3764 35.7009 53.0946 36.4188 53.0946 37.4716C53.0946 38.5723 52.3764 39.2902 51.3232 39.2902C50.2699 39.2902 49.5039 38.5723 49.5039 37.5195ZM51.3232 36.3709C50.7008 36.3709 50.3178 36.7538 50.3178 37.4238C50.3178 38.1416 50.7008 38.5723 51.3711 38.5723C51.9934 38.5723 52.4243 38.1895 52.4243 37.5195C52.3764 36.8495 51.9456 36.3709 51.3232 36.3709Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask3_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask3_4307_143312)">
          <path
            d="M58.7916 39.1944H55.7754V35.7966H56.5414V38.4766H58.7916V39.1944Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask4_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask4_4307_143312)">
          <path
            d="M61.2324 37.9502V35.8445H61.9506V37.8066C61.9506 38.333 62.2378 38.6202 62.8602 38.6202C63.4826 38.6202 63.7698 38.333 63.7698 37.8066V35.8445H64.488V37.9502C64.488 38.7637 63.8656 39.338 62.8602 39.338C61.8548 39.2901 61.2324 38.7637 61.2324 37.9502Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask5_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask5_4307_143312)">
          <path
            d="M67.8881 37.4716C67.8881 38.1895 68.4147 38.5723 69.0371 38.5723C69.5159 38.5723 69.9468 38.2373 70.0425 37.8066L70.6649 38.0938C70.5691 39.0509 69.7074 39.338 68.9414 39.338H68.8935L68.8456 39.4816C69.1807 39.5294 69.3244 39.7209 69.3244 39.9123C69.3244 40.1994 69.0371 40.4866 68.6062 40.4866C68.5105 40.4866 68.3669 40.4866 68.2232 40.3909L68.319 40.0559C68.4147 40.1037 68.4626 40.1037 68.5584 40.1037C68.702 40.1037 68.7499 40.008 68.7499 39.9602C68.7499 39.8644 68.6541 39.7687 68.5105 39.7687C68.4626 39.7687 68.4626 39.7687 68.4147 39.7687L68.5584 39.2423C67.6966 39.0987 67.0742 38.3809 67.0742 37.4238C67.0742 36.2752 67.8881 35.6531 68.9414 35.6531C69.851 35.6531 70.4734 36.0838 70.617 36.8016L69.9468 37.0409C69.8031 36.5623 69.2765 36.3709 68.8935 36.3709C68.319 36.4188 67.8881 36.8016 67.8881 37.4716Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask6_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask6_4307_143312)">
          <path
            d="M74.829 39.2903C73.7279 39.2903 73.0098 38.5724 73.0098 37.5196C73.0098 36.4189 73.7279 35.701 74.7812 35.701C75.8823 35.701 76.6004 36.4189 76.6004 37.4717C76.6004 38.5724 75.8823 39.2903 74.829 39.2903ZM75.8344 37.5674C75.8344 36.8496 75.4514 36.4189 74.7812 36.4189C74.1588 36.4189 73.7758 36.8017 73.7758 37.4717C73.7758 38.1896 74.1588 38.6203 74.829 38.6203C75.4514 38.6203 75.8344 38.1896 75.8344 37.5674ZM74.446 34.696C74.063 34.696 73.9194 34.9353 73.9194 35.366H74.2067C74.2067 35.2225 74.2545 35.1746 74.3503 35.1746C74.5418 35.1746 74.7812 35.366 75.1642 35.366C75.5951 35.366 75.6908 35.031 75.6908 34.696H75.4036C75.4036 34.8396 75.3557 34.8875 75.2599 34.8875C75.0684 34.8875 74.829 34.696 74.446 34.696Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask7_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask7_4307_143312)">
          <path
            d="M82.4889 39.1944H79.2812V35.7966H82.3932V36.5145H79.9994V37.0888H81.9623V37.8066H79.9994V38.4766H82.4889V39.1944Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask8_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask8_4307_143312)">
          <path
            d="M88.3299 38.0938C88.3299 39.0509 87.3723 39.2902 86.6542 39.2902C86.2233 39.2902 85.1222 39.2902 84.8828 38.2852L85.5531 37.9502C85.8403 38.4766 86.2712 38.5245 86.5585 38.5245C86.8457 38.5245 87.516 38.5245 87.516 38.1416C87.516 37.4238 84.8828 38.2852 84.8828 36.7538C84.8828 36.0359 85.7446 35.6531 86.5585 35.6531C87.3723 35.6531 88.1384 35.9881 88.2341 36.6581L87.6117 36.8973C87.4681 36.4666 86.9893 36.3231 86.5585 36.3231C86.1276 36.3231 85.6967 36.4666 85.6967 36.7059C85.7446 37.4238 88.3299 36.6581 88.3299 38.0938Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask9_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask9_4307_143312)">
          <path
            d="M96.8511 38.3809H95.0797C94.984 38.6202 94.8403 38.9073 94.6967 39.1944H93.8828L95.5106 35.7966H96.4202L98.048 39.1944H97.2341L96.8511 38.3809ZM95.4148 37.663H96.516L96.0372 36.658H95.8936C95.8936 36.7059 95.7021 37.0888 95.4148 37.663Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask10_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask10_4307_143312)">
          <path
            d="M102.405 37.9023L103.411 35.7966H104.32V39.1944H103.602V37.0888L102.597 39.1944H102.262L101.208 37.0888V39.1944H100.49V35.7966H101.448L102.405 37.9023Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask11_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask11_4307_143312)">
          <path
            d="M109.108 35.7966C109.779 35.7966 110.497 35.9402 110.497 36.7538C110.497 36.993 110.353 37.1845 110.209 37.3759C110.401 37.5673 110.545 37.7587 110.545 38.0459C110.545 39.003 109.683 39.1944 109.108 39.1944H107.289V35.7966H109.108ZM109.252 37.1366C109.491 37.1366 109.635 36.993 109.635 36.8016C109.635 36.658 109.539 36.5145 109.252 36.5145H107.959V37.0888H109.252V37.1366ZM107.959 38.4766C107.959 38.4766 108.965 38.4766 109.108 38.4766C109.396 38.4766 109.731 38.4287 109.731 38.0937C109.731 37.8066 109.396 37.8066 109.108 37.8066H107.959V38.4766Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask12_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask12_4307_143312)">
          <path d="M113.943 35.7966H113.225V39.1944H113.943V35.7966Z" fill="#006CB7" />
        </g>
        <mask
          id="mask13_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask13_4307_143312)">
          <path
            d="M120.071 39.1944H116.863V35.7966H120.023V36.5145H117.629V37.0888H119.592V37.8066H117.629V38.4766H120.071V39.1944Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask14_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask14_4307_143312)">
          <path
            d="M126.103 39.1944H125.385L123.47 36.9452V39.1944H122.752V35.7966H123.47L125.385 38.0459V35.7966H126.103V39.1944Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask15_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask15_4307_143312)">
          <path
            d="M132.184 36.5145H130.748V39.1944H130.03V36.5145H128.594V35.7966H132.184V36.5145Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask16_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask16_4307_143312)">
          <path
            d="M136.876 38.3809H135.105C135.009 38.6202 134.866 38.9073 134.722 39.1944H133.908L135.536 35.7966H136.446L138.073 39.1944H137.26L136.876 38.3809ZM135.44 37.663H136.541L136.063 36.658H135.919C135.919 36.7059 135.727 37.0888 135.44 37.663Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask17_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask17_4307_143312)">
          <path d="M141.234 35.7966H140.516V39.1944H141.234V35.7966Z" fill="#006CB7" />
        </g>
        <mask
          id="mask18_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="-138"
          width="145"
          height="182"
        >
          <path d="M147.361 -137.156H3.01562V43.7887H147.361V-137.156Z" fill="white" />
        </mask>
        <g mask="url(#mask18_4307_143312)">
          <path
            d="M147.361 38.0938C147.361 39.0509 146.404 39.2902 145.685 39.2902C145.255 39.2902 144.153 39.2902 143.914 38.2852L144.584 37.9502C144.872 38.4766 145.302 38.5245 145.59 38.5245C145.877 38.5245 146.547 38.5245 146.547 38.1416C146.547 37.4238 143.914 38.2852 143.914 36.7538C143.914 36.0359 144.776 35.6531 145.59 35.6531C146.404 35.6531 147.17 35.9881 147.217 36.6581L146.595 36.8973C146.451 36.4666 145.973 36.3231 145.542 36.3231C145.111 36.3231 144.68 36.4666 144.68 36.7059C144.776 37.4238 147.361 36.6581 147.361 38.0938Z"
            fill="#006CB7"
          />
        </g>
        <mask
          id="mask19_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="3"
          width="28"
          height="41"
        >
          <path
            d="M13.8849 6.31698L15.7999 7.1784C17.1883 7.80053 18.3374 9.14051 18.9119 10.7198C19.63 12.7297 19.4385 14.979 18.3852 17.0847L9.81548 31.9202C8.37921 34.4087 8.37921 37.3279 9.81548 39.8165C11.2518 42.305 13.7892 43.7407 16.6617 43.7407H35.2854C35.2854 43.7407 35.2854 41.8743 35.2854 41.6829C35.3332 41.0129 35.1417 39.9601 35.1417 39.9601H16.6138C15.1297 39.9601 13.7892 39.1943 13.0232 37.9022C12.2571 36.6101 12.2571 35.0787 13.0232 33.7866L21.6408 18.9032L21.6887 18.8075C23.2207 15.7447 23.5079 12.3947 22.4547 9.42765C21.4972 6.79555 19.63 4.73772 17.2841 3.68488L15.7999 3.06274L13.8849 6.31698Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask19_4307_143312)">
          <path
            d="M32.9391 -4.64209L46.9667 40.1515L10.8206 51.4935L-3.20703 6.69988L32.9391 -4.64209Z"
            fill="url(#paint0_radial_4307_143312)"
          />
        </g>
        <mask
          id="mask20_4307_143312"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="3"
          width="33"
          height="41"
        >
          <path
            d="M13.8837 6.31698L4.4522 22.6839C3.01593 25.1724 3.01593 28.0917 4.4522 30.5802C5.88847 33.0687 8.42589 34.5044 11.2984 34.5044H24.3685C26.4272 34.5044 28.1986 35.2223 29.5391 36.5622C30.8796 37.9501 31.6456 39.8643 31.5977 41.8743V43.7886H35.3799V41.97C35.4278 38.9551 34.3267 36.0358 32.268 33.978C30.2093 31.8723 27.5283 30.7716 24.4164 30.7716H11.2984C9.81428 30.7716 8.47376 30.0059 7.70775 28.7138C6.94174 27.4217 6.94174 25.8903 7.70775 24.5981L19.1022 4.78558C18.8628 4.59415 18.2404 4.16344 17.4744 3.78059L15.7987 3.06274L13.8837 6.31698Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask20_4307_143312)">
          <path
            d="M35.3796 3.06274H3.01562V43.7886H35.3796V3.06274Z"
            fill="url(#paint1_radial_4307_143312)"
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_4307_143312"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(5.09019 16.2184 16.225 -5.08814 11.6709 30.0649)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00467D" />
          <stop offset="0.2793" stopColor="#006CB7" />
          <stop offset="0.999" stopColor="#006CB7" />
          <stop offset="1" stopColor="#006CB7" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4307_143312"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.047 36.1016) scale(17.0367 17.0299)"
        >
          <stop stopColor="#9ACA3C" />
          <stop offset="0.6271" stopColor="#006CB7" />
          <stop offset="1" stopColor="#006CB7" />
        </radialGradient>
        <clipPath id="clip0_4307_143312">
          <rect width="151" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
